import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { GetQuizResponse } from "./getQuiz.types";

export const requestGetQuiz = async (): Promise<GetQuizResponse> => {
  return await instance.get(ApiRoutesContent.Quizzes);
};
